import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Guest from './guest';
import GuestDetail from './guest-detail';
import GuestUpdate from './guest-update';
import GuestDeleteDialog from './guest-delete-dialog';

const GuestRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Guest />} />
    <Route path="new" element={<GuestUpdate />} />
    <Route path=":id">
      <Route index element={<GuestDetail />} />
      <Route path="edit" element={<GuestUpdate />} />
      <Route path="delete" element={<GuestDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GuestRoutes;
